import React from "react";

export default function EatInForm({
  user,
  guestName,
  setGuestName,
  tableNumber,
  setTableNumber,
  notes,
  setNotes,
  canAddServiceCharge,
  addServiceCharge,
  setAddServiceCharge,
  serviceChargeAmount,
  getUserFullName,
}) {
  return (
    <section>
      <div className="space-y-6 p-2">
        <div>
          <h2 className="text-xl font-semibold text-black">
            Customer Information
          </h2>
          <p className="text-sm text-black/60">
            Enter your details to send your order to the kitchen.
          </p>
        </div>

        <div>
          <label className="block mb-2 text-sm font-medium text-black">
            Your Name
          </label>

          {user ? (
            <input
              type="text"
              value={getUserFullName()}
              readOnly
              required
              className="w-full rounded-2xl border border-black/20 bg-black/5 px-4 py-3.5 text-sm text-black outline-none"
            />
          ) : (
            <input
              type="text"
              value={guestName}
              onChange={(e) => setGuestName(e.target.value)}
              required
              placeholder="Enter your full name"
              className="w-full rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
            />
          )}
        </div>

        <div>
          <label className="block mb-2 text-sm font-medium text-black">
            Table Number
          </label>
          <input
            type="text"
            value={tableNumber}
            onChange={(e) => setTableNumber(e.target.value)}
            required
            placeholder="Enter your table number"
            className="w-full rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
          />
        </div>

        <div>
          <label className="block mb-2 text-sm font-medium text-black">
            Notes <span className="text-black/50">(optional)</span>
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={5}
            placeholder="Add any extra instructions"
            className="w-full resize-none rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
          />
        </div>

        {canAddServiceCharge && (
          <div className="rounded-2xl border border-[#fa9324]/40 bg-[#fa9324]/10 p-4">
            <label className="flex items-center justify-between cursor-pointer">
              <div>
                <p className="font-semibold text-black">Add Service Charge</p>
                <p className="text-sm text-black/60">
                  £{serviceChargeAmount.toFixed(2)} will be added
                </p>
              </div>

              <input
                type="checkbox"
                checked={addServiceCharge}
                onChange={() => setAddServiceCharge(!addServiceCharge)}
                className="h-5 w-5 accent-[#fa9324]"
              />
            </label>
          </div>
        )}
      </div>
    </section>
  );
}